import {
  ArrowCounterClockwise,
  ArrowSquareOut,
  Copy,
  CurrencyEur,
  DotsThreeVertical,
  Link,
  Note,
  Path,
  Pencil,
  Plus,
  QrCode,
  Shield,
  Tag,
  FileCsv,
  Eye,
  Medal,
  IdentificationCard,
  Info,
  ArrowRight,
  SlidersHorizontal,
  Trash,
  Users,
  Coins,
  Calendar,
  CreditCard,
  Clock,
  Gift,
  ChatCircleText,
  FilePdf,
  Paperclip,
  File,
  GraduationCap,
  ToggleRight,
  ToggleLeft,
  Download,
  Share,
  X,
  EnvelopeSimple,
  Check
} from '@phosphor-icons/react';
import React from 'react';

const icons = {
  ArrowSquareOut,
  Copy,
  DotsThreeVertical,
  Plus,
  ArrowCounterClockwise,
  Pencil,
  CurrencyEur,
  Link,
  Tag,
  Shield,
  Note,
  Path,
  QrCode,
  FileCsv,
  Eye,
  Medal,
  IdentificationCard,
  Info,
  ArrowRight,
  SlidersHorizontal,
  Trash,
  Users,
  Coins,
  Calendar,
  CreditCard,
  Clock,
  Gift,
  ChatCircleText,
  FilePdf,
  Paperclip,
  File,
  GraduationCap,
  ToggleOn: ToggleRight,
  ToggleOff: ToggleLeft,
  Download,
  Share,
  X,
  EnvelopeSimple,
  Check
};

const Icon = React.forwardRef(function (
  { name = '', size = 24, className = '', ...rest },
  ref
) {
  const Component = icons[name];
  return <Component ref={ref} size={size} className={className} {...rest} />;
});

export default Icon;
